var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "operations",
            staticStyle: { "margin-bottom": "5px" }
          },
          [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "new",
                        disabled: !_vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "edit",
                        disabled: !_vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: !_vm.isEdit, type: "danger" },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.doorName") } },
                    [
                      _c("el-input", {
                        attrs: { no: "name" },
                        model: {
                          value: _vm.editDialog.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "name", $$v)
                          },
                          expression: "editDialog.form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.contactPerson") } },
                    [
                      _c("el-input", {
                        attrs: { no: "contact" },
                        model: {
                          value: _vm.editDialog.form.contact,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "contact", $$v)
                          },
                          expression: "editDialog.form.contact"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "phone" },
                        model: {
                          value: _vm.editDialog.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "phone", $$v)
                          },
                          expression: "editDialog.form.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DoorAddress") } },
                    [
                      _c("el-input", {
                        attrs: { no: "address" },
                        model: {
                          value: _vm.editDialog.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "address", $$v)
                          },
                          expression: "editDialog.form.address"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "city",
                          cache: false,
                          filterable: "",
                          "default-value": _vm.editDialog.form.city,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: " ",
                          "static-options": _vm.locationList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.city = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                    [
                      _c("el-input", {
                        attrs: { no: "zipCode" },
                        model: {
                          value: _vm.editDialog.form.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "zipCode", $$v)
                          },
                          expression: "editDialog.form.zipCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c("cargo-area", {
                    ref: "area",
                    staticStyle: { display: "inline-block" },
                    attrs: {
                      no: "area",
                      country: _vm.editDialog.form.country,
                      province: _vm.editDialog.form.province,
                      city: _vm.editDialog.form.cityNew,
                      district: _vm.editDialog.form.county,
                      town: _vm.editDialog.form.town,
                      "district-label-name": _vm.$t(
                        "CargoMsg.Cargo_CountyDistrict"
                      ),
                      "town-label-name": _vm.$t("CargoMsg.Cargo_TownStreet"),
                      "label-width": "100",
                      "select-width": 280,
                      "show-town": true
                    },
                    on: {
                      "update:country": function($event) {
                        return _vm.$set(_vm.editDialog.form, "country", $event)
                      },
                      "update:province": function($event) {
                        return _vm.$set(_vm.editDialog.form, "province", $event)
                      },
                      "update:city": function($event) {
                        return _vm.$set(_vm.editDialog.form, "cityNew", $event)
                      },
                      "update:district": function($event) {
                        return _vm.$set(_vm.editDialog.form, "county", $event)
                      },
                      "update:town": function($event) {
                        return _vm.$set(_vm.editDialog.form, "town", $event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }